"use client";

import React, { useState, useEffect } from 'react';
import { FiMapPin, FiClock } from 'react-icons/fi';

const openingHoursData = {
  // 0: Domingo, 1: Lunes, etc.
  1: { day: 'Lunes', open: 9, close: 21, isClosed: false },
  2: { day: 'Martes', open: 9, close: 21, isClosed: false },
  3: { day: 'Miércoles', open: 9, close: 21, isClosed: false },
  4: { day: 'Jueves', open: 9, close: 21, isClosed: false },
  5: { day: 'Viernes', open: 9, close: 21, isClosed: false },
  6: { day: 'Sábado', open: 10, close: 19, isClosed: false },
  0: { day: 'Domingo', isClosed: true },
};

const BusinessInfo = () => {
  const [status, setStatus] = useState({ isOpen: false, text: 'Cerrado' });
  const [currentDay, setCurrentDay] = useState(new Date().getDay());
  const dayIndexMap = { 'Domingo': 0, 'Lunes': 1, 'Martes': 2, 'Miércoles': 3, 'Jueves': 4, 'Viernes': 5, 'Sábado': 6 };

  useEffect(() => {
    const checkStatus = () => {
      const now = new Date();
      const dayOfWeek = now.getDay();
      const currentHour = now.getHours();
      const schedule = openingHoursData[dayOfWeek];

      if (schedule && !schedule.isClosed) {
        if (currentHour >= schedule.open && currentHour < schedule.close) {
          setStatus({ isOpen: true, text: 'Abierto ahora' });
        } else {
          setStatus({ isOpen: false, text: 'Cerrado ahora' });
        }
      } else {
        setStatus({ isOpen: false, text: 'Cerrado ahora' });
      }
      setCurrentDay(dayOfWeek);
    };

    checkStatus();
    const interval = setInterval(checkStatus, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-gradient-to-b from-white to-primary-50/30 py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="rounded-2xl border border-neutral-200 bg-white/95 p-8 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-3 border-b border-neutral-100 pb-6">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold text-neutral-900">Horario de apertura</h3>
                <span
                  className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider ${
                    status.isOpen
                      ? 'bg-emerald-100 text-emerald-700'
                      : 'bg-neutral-100 text-neutral-600'
                  }`}
                >
                  <span className={`h-2.5 w-2.5 rounded-full ${status.isOpen ? 'bg-emerald-500' : 'bg-neutral-400'}`} />
                  {status.text}
                </span>
              </div>
              <p className="text-sm text-neutral-600">
                Encuéntranos en nuestro horario habitual. ¡Te esperamos!
              </p>
            </div>

            <ul className="mt-6 space-y-3 text-sm text-neutral-700">
              {Object.values(openingHoursData).map((item) => {
                const isToday = currentDay === dayIndexMap[item.day]

                return (
                  <li
                    key={item.day}
                    className={`flex items-center justify-between rounded-xl border px-4 py-3 transition ${
                      isToday
                        ? 'border-primary-200 bg-primary-50/60 text-primary-700'
                        : 'border-neutral-200 bg-white'
                    }`}
                  >
                    <span className="font-medium">{item.day}</span>
                    <span className="text-sm font-semibold">
                      {item.isClosed ? 'Cerrado' : `${item.open}:00 - ${item.close}:00`}
                    </span>
                  </li>
                )
              })}
            </ul>
          </div>

          <div className="rounded-2xl border border-neutral-200 bg-white/95 p-6 shadow-sm backdrop-blur">
            <div className="mb-4 flex items-center gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary-50 text-primary-600">
                <FiMapPin className="h-5 w-5" />
              </span>
              <div>
                <h4 className="text-base font-semibold text-neutral-900">Nuestra ubicación</h4>
                <p className="text-sm text-neutral-600">Mac Iver 1664, Concepción, Chile</p>
              </div>
            </div>

            <div className="relative overflow-hidden rounded-xl border border-neutral-200">
              <div className="aspect-[4/3]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.8141165317365!2d-73.03809032418273!3d-36.8229739780657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9669b42defe8f76d%3A0x774d5da153afc3fe!2zTWFjIEl2ZXIgMTY2NCwgNDA3MDM2MCBDb25jZXBjacOzbiwgQsOtbyBCw61v!5e0!3m2!1ses-419!2scl!4v1753309091683!5m2!1ses-419!2scl"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación IntegraMente HWH"
                />
              </div>
            </div>

            <div className="mt-6 flex items-center justify-between rounded-xl bg-neutral-50 px-4 py-3 text-sm text-neutral-600">
              <div className="flex items-center gap-2">
                <FiClock className="h-4 w-4" />
                <span>Lunes a Viernes</span>
              </div>
              <span className="font-semibold text-neutral-900">09:00 - 20:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessInfo;


